import React from 'react';
import { Plus, Search, X } from 'lucide-react';

const Searchbar = ({
  searchTerm,
  setSearchTerm,
  onClearSearch,
  placeholder = 'Try "keyword", "keyword"',
  inputRef,
  onCreateItem,
  id,
}) => {
  const trimmedSearch = searchTerm.trim();
  const hasClearButton = Boolean(searchTerm);
  const showCreateItem = Boolean(onCreateItem) && Boolean(trimmedSearch);

  let inputRightPadding = 'pr-10 sm:pr-12';
  if (showCreateItem && hasClearButton) {
    inputRightPadding = 'pr-28 sm:pr-44';
  } else if (showCreateItem) {
    inputRightPadding = 'pr-16 sm:pr-36';
  } else if (hasClearButton) {
    inputRightPadding = 'pr-16 sm:pr-20';
  }

  const handleCreateItem = () => {
    onCreateItem?.();
  };

  return (
    <div className="relative">
      <div className="relative flex items-center">
        <Search className="absolute left-2.5 text-neutral-500" size={18} />
        <input
          ref={inputRef}
          id={id}
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder={placeholder}
          className={`w-full pl-9 ${inputRightPadding} py-3 border-2 border-neutral-900 rounded-xl focus:outline-none focus:ring-2 focus:ring-cranberry-700 placeholder:italic text-base touch-manipulation min-h-[48px]`}
        />
        <div className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center gap-1">
          {showCreateItem && (
            <button
              type="button"
              onClick={handleCreateItem}
              className="inline-flex items-center gap-1 px-2.5 py-1.5 bg-cranberry-700 text-white rounded-lg text-sm font-medium hover:bg-cranberry-600 transition-colors whitespace-nowrap focus:outline-none focus:ring-2 focus:ring-cranberry-800"
              aria-label={`Create item named ${trimmedSearch}`}
            >
              <Plus size={16} aria-hidden="true" />
              <span className="hidden sm:inline">Create item</span>
            </button>
          )}
          {hasClearButton && (
            <button
              type="button"
              onClick={onClearSearch}
              className="p-1.5 text-neutral-400 hover:text-neutral-600 active:bg-gray-100 rounded-lg transition-colors touch-manipulation min-w-[44px] min-h-[44px] flex items-center justify-center"
              aria-label="Clear search"
            >
              <X size={18} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Searchbar;
